import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Package, 
  Warehouse, 
  ShoppingBag,
  Mail,
  AlertTriangle, 
  BarChart3, 
  LogOut,
  Settings
} from 'lucide-react';

const AdminSidebar = ({ onLogout }) => {
  const location = useLocation();
  
  const menuItems = [
    {
      path: '/admin/dashboard',
      icon: LayoutDashboard,
      label: 'Dashboard',
      testId: 'admin-nav-dashboard'
    },
    {
      path: '/admin/dashboard/products',
      icon: Package,
      label: 'Products',
      testId: 'admin-nav-products'
    },
    {
      path: '/admin/dashboard/inventory',
      icon: Warehouse,
      label: 'Inventory',
      testId: 'admin-nav-inventory'
    },
    {
      path: '/admin/dashboard/orders',
      icon: ShoppingBag,
      label: 'Orders',
      testId: 'admin-nav-orders'
    },
    {
      path: '/admin/dashboard/messages',
      icon: Mail,
      label: 'Messages',
      testId: 'admin-nav-messages'
    },
    {
      path: '/admin/dashboard/alerts',
      icon: AlertTriangle,
      label: 'Stock Alerts',
      testId: 'admin-nav-alerts'
    },
    {
      path: '/admin/dashboard/analytics',
      icon: BarChart3,
      label: 'Analytics',
      testId: 'admin-nav-analytics'
    }
  ];

  const handleLogout = () => {
    localStorage.removeItem('kicks_admin_logged_in');
    onLogout(false);
  };

  return (
    <div className="fixed left-0 top-0 h-full w-64 bg-white shadow-lg border-r border-gray-200 z-40">
      {/* Logo */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center">
          <img 
            src="https://res.cloudinary.com/dm8rx6sks/image/upload/v1762202240/sneaker-store/branding/bx-kicks-logo-white.png" 
            alt="BX Kicks Logo" 
            className="h-12 w-auto rounded-lg"
          />
        </div>
        <p className="text-sm text-gray-500 mt-2">Admin Panel</p>
      </div>

      {/* Navigation */}
      <nav className="p-4">
        <div className="space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <Link
                key={item.path}
                to={item.path}
                data-testid={item.testId}
                className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                  isActive
                    ? 'bg-brand-purple text-white'
                    : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                }`}
              >
                <Icon className="w-5 h-5" />
                <span className="font-medium">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>

      {/* Bottom Actions */}
      <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200">
        <button
          onClick={handleLogout}
          className="flex items-center space-x-3 px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 hover:text-red-700 transition-colors w-full"
          data-testid="admin-logout-button"
        >
          <LogOut className="w-5 h-5" />
          <span className="font-medium">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default AdminSidebar;